<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="!data || !data['id']">Add Lecture</h5>
                    <h5 class="modal-title" *ngIf="data && data['id']">Update Lecture</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addLectureForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>University</label>
                                        <select class="form-control" id="university_id" formControlName="university_id">
                                            <option value="">Select University</option>
                                            <option [value]="uni?.id"
                                                    *ngFor="let uni of universities">{{ uni.name }}
                                            </option>
                                        </select>
                                        <small *ngIf="submitted && addLectureForm.get('university_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Course</label>
                                        <select class="form-control" id="course_id" formControlName="course_id">
                                            <option value="">Select Course</option>
                                            <option [value]="course?.id"
                                                    *ngFor="let course of courses">{{ course.name }}
                                            </option>
                                        </select>
                                        <small *ngIf="submitted && addLectureForm.get('course_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Category</label>
                                        <select class="form-control" id="category_id" formControlName="category_id">
                                            <option value="">Select Category</option>
                                            <option [value]="cat?.id"
                                                    *ngFor="let cat of category">{{ cat.name }}
                                            </option>
                                        </select>
                                        <small *ngIf="submitted && addLectureForm.get('category_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Semester</label>
                                        <select class="form-control" id="semester" formControlName="semester">
                                            <option value="">Select Semester</option>
                                            <option [value]="sem" *ngFor="let sem of semesters">{{ sem }}</option>
                                        </select>
                                        <small *ngIf="submitted && addLectureForm.get('semester').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="name">Name</label>
                                        <input class="form-control" id="name" type="text" formControlName="name">
                                        <small *ngIf="submitted && addLectureForm.get('name').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Upload Video</label>

                                        <div class="d-flex align-items-center">
                                            <button
                                                    type="button"
                                                    class="btn btn-primary mr-2"
                                                    [disabled]="uploadingVideo"
                                                    (click)="videoUpload.click()">
                                                <i class="fas fa-spinner fa-spin mr-1" *ngIf="uploadingVideo"></i>
                                                <i class="fas fa-cloud-upload-alt" *ngIf="!uploadingVideo"></i>
                                                {{ uploadingVideo ? 'Uploading...' : 'Upload' }}
                                            </button>

                                            <i
                                                    *ngIf="uploadingVideo"
                                                    class="fas fa-spinner fa-spin f_20 text-primary ml-1"
                                                    title="Uploading video"
                                            ></i>

                                            <i
                                                    *ngIf="!uploadingVideo && uploadedVideoUrl"
                                                    class="fas fa-eye f_20 text-success cursor-pointer ml-1"
                                                    title="View Video"
                                                    (click)="openUploadedVideo()"
                                            ></i>
                                        </div>

                                        <input
                                                type="file"
                                                class="form-control-file d-none"
                                                accept="video/*"
                                                (change)="onVideoFileChange($event, 'LECTURE')"
                                                #videoUpload
                                        >
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <button rippleEffect type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close" (click)="toggleSidebar()"> cancel
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="submit()" *ngIf="!data || !data['id']">Submit
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="update()" *ngIf="data && data['id']">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
</div>
